'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var hooks_useCombinedRefs = require('../../hooks/useCombinedRefs.js');
var useDevelopmentEffect = require('../../_chunks/useDevelopmentEffect-DGG0KnB_.js');
var hooks_useFocus = require('../../hooks/useFocus.js');
var hooks_useHover = require('../../hooks/useHover.js');
var hooks_useUUID = require('../../hooks/useUUID.js');
var useOnEscape = require('../../_chunks/useOnEscape-vb8gPtDo.js');
var components_floatingContainer_FloatingContainer = require('../floatingContainer/FloatingContainer.js');
var utilities_combineClasses = require('../../_chunks/combineClasses-5P8GTQkg.js');
require('lodash/isNumber');
require('../../_chunks/useEventListener-DSwo06ND.js');
require('../../hooks/useCallbackRef.js');
require('@floating-ui/react-dom');
require('../../transitions/fade/Fade.js');
require('react-transition-group');
require('../portal/Portal.js');
require('react-dom');
require('../../theme/ThemeProvider.js');
require('../../_chunks/index-CIVOGJRG.js');
require('../../_chunks/designTokens-CKP-YoT2.js');

require("../../_assets/Tooltip-CUL0bCfz.css");var styles = {"tooltip":"Tooltip__-4xgBmwlGc__tooltip","tooltipContent":"Tooltip__-4xgBmwlGc__tooltipContent"};

const Tooltip = react.forwardRef(({ text, className, active = true, attachAs = 'description', children, ...props }, ref) => {
    const id = hooks_useUUID.useUUID({ prefix: 'tooltip' });
    const anchorRef = react.useRef(null);
    const [anchorHoverRef, isAnchorHovered] = hooks_useHover.useHover({
        delay: { hover: 300, unhover: 100 },
    });
    const [tooltipHoverRef, isTooltipHovered] = hooks_useHover.useHover();
    const [anchorFocusRef, isAnchorFocused] = hooks_useFocus.useFocus();
    const [isAnchorTriggered, setIsAnchorTriggered] = react.useState(false);
    const isExpanded = isAnchorTriggered || isTooltipHovered;
    // floating-ui updates its state in its ref callback, therefore we need to memoize the combined ref functions
    const combinedAnchorRef = hooks_useCombinedRefs.useCombinedRefs(children.ref, anchorRef, anchorHoverRef, anchorFocusRef);
    const combinedTooltipRef = hooks_useCombinedRefs.useCombinedRefs(tooltipHoverRef, ref);
    // the tooltip should be triggerable by both hover and focus https://www.w3.org/TR/WCAG21/#content-on-hover-or-focus
    react.useEffect(() => {
        setIsAnchorTriggered(isAnchorFocused);
    }, [isAnchorFocused]);
    react.useEffect(() => {
        setIsAnchorTriggered(isAnchorHovered);
    }, [isAnchorHovered]);
    // content that's displayed on hover and focus should be dismissible without moving the pointer or the focus
    // https://www.w3.org/TR/WCAG21/#content-on-hover-or-focus
    useOnEscape.useOnEscape(() => setIsAnchorTriggered(false), { element: document });
    useDevelopmentEffect.useDevelopmentEffect(() => {
        if (children.type === react.Fragment) {
            console.error('[Tooltip] The child must not be a fragment as it must be able to hold a reference and handle aria-* attributes.');
        }
    }, [children]);
    if (!active || !text) {
        return children;
    }
    return (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [react.cloneElement(children, {
                ref: combinedAnchorRef,
                // https://w3c.github.io/aria-practices/#tooltip
                'aria-describedby': attachAs === 'description'
                    ? [id, children.props['aria-describedby']]
                        .filter(Boolean)
                        .join(' ')
                    : undefined,
                'aria-labelledby': attachAs === 'label'
                    ? [id, children.props['aria-labelledby']]
                        .filter(Boolean)
                        .join(' ')
                    : undefined,
            }), jsxRuntime.jsx(components_floatingContainer_FloatingContainer.FloatingContainer, { unmountOnExit: 
                // keeping the tooltip in the dom even when it's not visible so it can still label/describe
                // its child even when it's inactive
                false, arrow: true, portal: true, open: isExpanded, placement: "top", shift: true, anchorRef: anchorRef, ref: combinedTooltipRef, role: attachAs === 'description' ? 'tooltip' : undefined, id: id, className: utilities_combineClasses.combineClasses(className, styles.tooltip), contentProps: { className: styles.tooltipContent }, "aria-hidden": 
                // invisible elements work as labels and descriptions. By aria-hiding the tooltips when they are not expanded,
                // we avoid crowding the bottom of the page with invisible content that's still accessible to screen readers.
                // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-describedby#description
                // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-labelledby#benefits_and_drawbacks
                !isExpanded || attachAs === 'visual only', ...props, children: text })] }));
});
Tooltip.displayName = 'Tooltip';

exports.Tooltip = Tooltip;
//# sourceMappingURL=Tooltip.js.map
